/** Textes partagés par le solo et le jeu entre amis. */
import type { CalibrationError } from '../detection/calibration';
import type { GameMode } from '../game/protocol';

/** Textes qui dépendent du mode : rire ou clignement. */
export const TEXTS: Record<GameMode, { calibrating: string; notSerious: string; lost: string }> = {
  laugh: {
    calibrating: 'Prends ton air sérieux… on calibre (3 s)',
    notSerious: 'Tu souris déjà ! Prends ton air sérieux…',
    lost: 'Tu as craqué !',
  },
  blink: {
    calibrating: 'Ouvre grand les yeux… on calibre (3 s)',
    notSerious: 'Tes yeux sont presque fermés ! Ouvre-les grand…',
    lost: 'Tu as cligné !',
  },
};

export function calibrationMessage(mode: GameMode, error: CalibrationError, fps?: number): string {
  switch (error) {
    case 'noFace':
      return 'On ne voit pas bien ton visage. Mets-toi face à la caméra, bien éclairé.';
    case 'notEnoughSamples':
      return 'La caméra est trop lente, on réessaie…';
    case 'notSerious':
      return TEXTS[mode].notSerious;
    case 'tooSlow':
      return `Ton appareil analyse ${fps === undefined ? 'trop peu' : fps.toFixed(0)} images par seconde : il en faut au moins 20 pour voir un clignement. Essaie le mode « rit », ou ferme d'autres onglets.`;
  }
}
